export const loadAndWatchReducer = (state, action, attr_name) => {
  const action_type = action.type.split('.')[1].split('_')[0];
  const branch = action.type
    .split('.')[1]
    .split('_')[1]
    .toLowerCase();
  attr_name = attr_name || branch;
  const key = action.payload.key || 'id';

  switch (action_type) {
    case 'LOAD':
      action.payload.data && delete action.payload.data.dummy;
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], [attr_name]: action.payload.data }
      };
    case 'ADD':
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          [attr_name]: { ...state[action.payload.id][attr_name], [action.payload.data[key]]: action.payload.data }
        }
      };
    case 'UPDATE':
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          [attr_name]: { ...state[action.payload.id][attr_name], [action.payload.data[key]]: action.payload.data }
        }
      };
    case 'REMOVE':
      const newData = { ...state[action.payload.id][attr_name] };
      delete newData[action.payload.data[key]];
      return { ...state, [action.payload.id]: { ...state[action.payload.id], [attr_name]: newData } };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/load_and_watch.js